import React from 'react';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';

import { TFormInputProps } from '@/shared/components/ui/form/components/form-input/form-input.types';
import { IpAddressSlot } from '@/shared/components/ui/form/components/form-input/variant/ip-address-form-input/components/ip-address-slot/ip-address-slot';
import { TextField } from '@/shared/components/ui/form/components/text-field/text-field';

export const IpAddressFormInput = <TFieldValues extends FieldValues>({
  name,
  label,
  placeholder,
  ...rest
}: Omit<TFormInputProps<TFieldValues>, 'type'>) => {
  const { control } = useFormContext<TFieldValues>();

  const _placeholder = placeholder ?? '0.0.0.0';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          type="text"
          label={label}
          error={!!fieldState?.error}
          fullWidth
          placeholder={_placeholder}
          helperText={fieldState.error?.message}
          {...rest}
          {...field}
          value={field.value ?? ''} // Keep this to prevent uncontrolled component error
          slotProps={{
            input: {
              inputComponent: IpAddressSlot as any,
              inputProps: {
                name: field.name,
              },
            },
          }}
        />
      )}
    />
  );
};
